import React from "react";
import { businessTools } from "../data/businessTools";
import "./BusinessToolsSection.css";

export default function BusinessToolsSection() {
  return (
    <section className="business-tools-section" id="business-tools">
      <span id="solutions-anchor" aria-hidden="true" className="business-tools-anchor" />

      <div className="business-tools-container">
        <div className="business-tools-header">
          <p className="business-tools-kicker">Recommended Business Tools</p>

          <div className="business-tools-heading-grid">
            <h2>Tools we recommend, configure, and connect to your workflow.</h2>

            <p>
              FIKAMI does not just share software links. We recommend tools that
              can help your business operate better — then we configure them so
              they actually fit your process.
            </p>
          </div>
        </div>

        <div className="business-tools-grid">
          {businessTools.map((tool) => (
            <article className="business-tool-card" key={tool.id}>
              <div className="business-tool-visual" aria-hidden="true">
                <div className="business-tool-logo-frame">
                  <img
                    className="business-tool-logo"
                    src={tool.logoUrl}
                    alt=""
                    loading="lazy"
                  />
                </div>

                <div className="business-tool-platform-pill">
                  {tool.category}
                </div>
              </div>

              <div className="business-tool-main">
                <div className="business-tool-card-top">
                  <span className="business-tool-label">{tool.label}</span>
                  <span className="business-tool-category">{tool.category}</span>
                </div>

                <div className="business-tool-content">
                  <h3>{tool.name}</h3>
                  <h4>{tool.headline}</h4>

                  <p className="business-tool-short">{tool.shortDescription}</p>
                  <p className="business-tool-description">{tool.description}</p>

                  <ul className="business-tool-usecases">
                    {tool.useCases.map((useCase) => (
                      <li key={useCase}>{useCase}</li>
                    ))}
                  </ul>
                </div>

                <div className="business-tool-actions">
                  <a className="business-tool-primary" href={tool.serviceUrl}>
                    {tool.serviceCta}
                  </a>

                  <a
                    className="business-tool-secondary"
                    href={tool.directUrl}
                    target="_blank"
                    rel="sponsored noopener noreferrer"
                  >
                    {tool.directCta}
                  </a>
                </div>

                {tool.disclosure && (
                  <p className="business-tool-disclosure">{tool.disclosure}</p>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
